import { every } from 'lodash';

import { PasswordRequirement } from '../types';

const requirements: PasswordRequirement[] = [
  {
    text: 'At least 10 characters in length',
    validation: (password: string) => password.length >= 10,
  },
  {
    text: 'At least 3 of the following:',
    validation: (_, children?: PasswordRequirement[]) =>
      children ? children.filter((child) => child.valid).length >= 3 : false,
    children: [
      {
        text: 'Lower case letters (a-z)',
        validation: (password: string) => /[a-z]/.test(password),
      },
      {
        text: 'Upper case letters (A-Z)',
        validation: (password: string) => /[A-Z]/.test(password),
      },
      {
        text: 'Numbers (0-9)',
        validation: (password: string) => /[0-9]/.test(password),
      },
      {
        text: 'Special characters (ex. !@#)',
        validation: (password: string) => /[^a-zA-Z0-9]/.test(password),
      },
    ],
  },
  {
    text: 'No more than 2 identical characters in a row',
    validation: (password: string) => !/(.)\1\1/.test(password),
  },
];

const validatePassword = (password?: string) => {
  if (!password) return { valid: false, requirements: [] };

  const testRequirement = (
    requirement: PasswordRequirement,
    password: string
  ) => {
    requirement.valid = requirement.validation(
      password,
      requirement.children?.map((child) => testRequirement(child, password))
    );
    return requirement;
  };

  const evaluatedRequirements = requirements.map((req) =>
    testRequirement(req, password)
  );

  return {
    valid: every(evaluatedRequirements, 'valid'),
    requirements: evaluatedRequirements,
  };
};

export default validatePassword;
